module.exports = __webpack_public_path__ + "static/img/pc-slogn.006b2bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/1yuan/pc-slogn.png
// module id = waOh
// module chunks = 1